var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMountain1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#f2f5ff",
    d: "M5 4h1M4 5h2M3 6h3M2 7h1m2 0h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b0cee8",
    d: "M6 4h1M6 5h2M6 6h3M7 7h1m1 0h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#394d56",
    d: "M3 7h2M1 8h5M0 9h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1b2b3a",
    d: "M6 7h1m1 0h1M6 8h5M6 9h6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain1);
export default __webpack_public_path__ + "static/media/mountain1.1955eaaff4e6cb66f723716689a2c070.svg";
export { ForwardRef as ReactComponent };